/* eslint-disable no-dupe-keys */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from 'react-helmet';

// import "./usersManagement.scss";
import UsersManagementComponent from "./usersManagementComponent";
import Select, { components } from "react-select";
import {
  getUserList,
  editUser,
  userDelete,
  userEditStatus,
  deleteUserReduxState,
  editUserStatusReduxState,
  editUserSignStatusReduxState,
  addcsvBulkUser,
} from "../../store/usersManagement/actions";

import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import scotRail_ImportUsers from "../../assets/csvFile/scotRail_ImportUsers.csv";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import { showToast } from "../../store/toast/actions";
import { debounce } from "lodash";
import Papa from "papaparse";
import Constant from "../../util/constant";

const UsersManagementContainer = (props) => {
  const smarttableref = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userList = useSelector((state) => state?.Users?.usersList?.data);
  const tableName = "TableUserMangment";
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const dimensions = useWindowDimension();
  const tableContainerRef = useRef(null);
  const pageSizeRef = useRef(dimensions.width > 1920 ? 25 : 10);
  // const pageSizeRef = useRef(10);
  const toggleDisable = useRef(false);
  const [loaderButtonShow, setLoaderButtonShow] = useState(false);
  const [disableModelLoaderBotton, setDisableModelLoaderBotton] =
    useState(false);
  const [showImportUserModal, setshowImportUserModal] = useState(false);
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const [uploadedUserFile, setuploadedUserFile] = useState(null);
  const [mobileuserOptions, setMobileuserOptions] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [headerHeight, setHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [depotOptions, setDepotOptions] = useState([]);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedMonbileuser, setSelectedMonbileuser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [depotMultiSelectarray, setDepotMultiSelectarray] = useState([]);
  const [searchedData, setSearchedData] = useState(userList);
  // uploaded user file
  const [enableDisableID, setEnableDisableID] = useState("");

  const [roleOptions, setRoleOptions] = useState([]);

  const [tableFilterHeight, setTableFilterHeight] = useState("");

  const [csvParsedData, setcsvParsedData] = useState([]);
  // show success modal
  const [showCsvSuccessModal, setshowCsvSuccessModal] = useState(false);
  // success modal data
  const [successModalCsvData, setsuccessModalCsvData] = useState({
    title: "",
    emptyRows: [],
    validRows: [],
    invalidRows: [],
    total: 0,
    failed: 0,
  });
  
  /**
   * Handles the closing of the CSV success modal.
   * Sets the state variable `showCsvSuccessModal` to `false`.
   * Calls the `getList` function to update the list.
   * @returns None
   */
  const handleCsvSuccessModalClose = () => {
    setshowCsvSuccessModal(false);
    getList();
  };
  /**
   * Opens the CSV success modal.
   * @returns None
   */
  const openCsvSuccessModal = () => {
    setshowCsvSuccessModal(true);
  };

  /**
   * useEffect hook that sets various heights based on the elements in the DOM.
   * @param {{boolean}} loading - Indicates whether the page is currently loading.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0].offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );

    setTableFilterHeight(
      document.getElementsByClassName("col-form-label")[0].offsetHeight
    );

    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
  }, [loading]);

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Retrieves the user list from the server and updates the state accordingly.
   * @returns None
   */
  const getList = () => {
    dispatch(
      getUserList(
        (res) => {
          setPlaceHolder(false);
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  const bulkUserDataShowModal = (data) => {
    setshowImportUserModal(false);
  };

  /**
   * Executes a side effect when the `successModalCsvData` object changes.
   * If the `title` property of `successModalCsvData` is not an empty string,
   * it calls the `openCsvSuccessModal` function.
   * @returns None
   */
  useEffect(() => {
    if (successModalCsvData?.title !== "") {
      openCsvSuccessModal();
    }
  }, [successModalCsvData]);

  /**
   * Handles the bulk user add functionality by reading a file and parsing its contents as CSV.
   * @param {{File}} file - The file to be read and parsed.
   * @returns None
   */
  const handleBulkUserAdd = (file) => {
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = await Papa.parse(target.result, {
        header: true,
        chunkSize: 1000000,
        skipEmptyLines: true
      });
            setcsvParsedData(csv.data);
    };
    reader.readAsText(file[0]);
  };

  const columns = [
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "fullname",
      filter: false,
      sorter: true,
    },
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "emailid",
      filter: false,
      sorter: true,
    },
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "phone",
      filter: false,
      sorter: true,
    },
    {
      label: <>{t("ROLE")}</>,
      key: "role",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const roleOptions = unique.map((element) => ({
          value: element.toLowerCase(),
          label: element,
        }));

        const handleChange = (selected) => {
          const selectedValue = selected ? selected.value : null;

          if (selectedValue === selectedRole) {
            setSelectedRole(null);
            setRoleOptions([]); // Clear selected options
            onChange(() => true); // Reset the filter
          } else {
            setSelectedRole(selectedValue);
            setRoleOptions([selectedValue]); // Set selected options
            onChange((item) =>
              selectedValue !== null
                ? item.toLowerCase() === selectedValue
                : true
            );
          }

          // This should work only when clicking on the selected option again
          if (selectedValue === selectedRole) {
            smarttableref.current.querySelectorAll("button")[0].click();
          }
        };

        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };

        return (
          <Select
            isMulti={false}
            onChange={handleChange}
            closeMenuOnSelect={false}
            isClearable={true}
            placeholder={t("SELECT")}
            options={roleOptions}
            defaultValue={selectedRole}
            hideSelectedOptions={false}
            components={{ Option: CustomOption }}
            className="react-select-container singleSelecter"
            classNamePrefix="react-select"
          />
        );
      },
      sorter: false,
    },
    {
      label: <>{t("PAY_NUMBER")}</>,
      key: "payno",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("DEPOT")}</>,
      key: "depotname",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const _depotOptions = unique?.map((elementdepot) =>
          elementdepot?.map((item) => ({
            label: item?.depotname,
            value: item?.depotname,
          }))
        );
        let finalarr = [];
        const depotOptions = _depotOptions?.flatMap((item) => item);
        depotOptions?.forEach((item) => {
          let options = finalarr?.map((i) => i.label);
          if (!options?.includes(item?.label)) {
            finalarr.push(item);
          }
        });
        const handleChange = (selected) => {
          setDepotMultiSelectarray(selected);
          const selectedValues = selected?.map(
            (elementdepot) => elementdepot?.value
          );
          setDepotOptions(selectedValues);
          /**
           * Event handler for the onChange event.
           * @param {{item}} item - The item that triggered the onChange event.
           * @returns {boolean} - Returns true if the selectedValues array contains the depotname of the first item in the _filterValue array, or if the selectedValues array is empty. Returns false otherwise.
           */
          onChange((item) => {
            // eslint-disable-next-line array-callback-return
            const _filterValue = item?.filter((innerItem) => {
              if (selectedValues?.includes(innerItem?.depotname)) {
                return innerItem;
              }
            });
            return Array.isArray(selectedValues) && selectedValues?.length
              ? selectedValues?.includes(_filterValue[0]?.depotname)
              : true;
          });
        };
        /**
         * A custom option component for a select dropdown.
         * @param {{ReactNode}} children - The content of the option.
         * @param {{any}} props - Additional props for the option component.
         * @returns The custom option component.
         */
        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };
        return (
          <div
            className={
              depotMultiSelectarray?.length > 1
                ? "multipleselectWrapper customeSelectWrapper"
                : "customeSelectWrapper"
            }
          >
            <Select
              closeMenuOnSelect={false}
              isMulti
              onChange={handleChange}
              options={finalarr}
              hideSelectedOptions={false}
              isClearable={true}
              placeholder={t("SELECT")}
              components={{ Option: CustomOption }}
              className="react-select-container multiSelecter"
              classNamePrefix="react-select"
            // defaultValue={{ value: 'demoo', label: 'demoo' }}

            />
            {depotMultiSelectarray?.length > 1 && (
              <p className="multiselectTag">
                +{depotMultiSelectarray?.slice(1)?.length}
              </p>
            )}
          </div>
        );
      },
      sorter: false,
    },
    {
      label: <>{t("IS_MOBILE_USER")}</>,
      key: "allowmobilelogin",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const mobileuserOptions = unique.map((elementmobileuser) => ({
          value: elementmobileuser,
          label: elementmobileuser === true ? "Yes" : "No",
        }));

        const handleChange = (selected) => {
          const selectedValue = selected ? selected.value : null;
          // Toggle deselection when clicking the selected option again
          if (selectedValue === selectedMonbileuser) {
            setSelectedMonbileuser(null);
            setMobileuserOptions([]); // Clear the selected options array
            onChange(() => true); // Reset the filter
          } else {
            setSelectedMonbileuser(selectedValue);
            setMobileuserOptions([selectedValue]);
            onChange((item) => {
              return selectedValue !== null ? item === selectedValue : true;
            });
          }
          if (selectedValue === selectedMonbileuser) {
            smarttableref.current.querySelectorAll("button")[0].click();
          }
        };

        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };

        return (
          <Select
            isMulti={false}
            onChange={handleChange}
            closeMenuOnSelect={false}
            isClearable
            placeholder={t("SELECT")}
            options={mobileuserOptions}
            defaultValue={selectedMonbileuser}
            hideSelectedOptions={false}
            components={{ Option: CustomOption }}
            className="react-select-container singleSelecter"
            classNamePrefix="react-select"
          />
        );
      },
      sorter: false,
    },
    {
      label: <>{t("STATUS")}</>,
      key: "userstatus",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const statusOptions = unique.map((elementstatus) => ({
          value: elementstatus,
          label:
            elementstatus === Constant.GENERALKEYS.ACTIVE
              ? Constant.GENERALKEYS.ACTIVE
              : "Blocked",
        }));
        const handleChange = (selected) => {
          const selectedValue = selected ? selected.value : null;
          // Toggle deselection when clicking the selected option again
          if (selectedValue === selectedStatus) {
            setSelectedStatus(null);
            setStatusOptions([]); // Clear the selected options array
            smarttableref.current.querySelectorAll("button")[0].click();
          } else {
            setSelectedStatus(selectedValue);
            setStatusOptions([selectedValue]);
            onChange((item) => {
              return selectedValue !== null ? item === selectedValue : true;
            });
          }
          if (selectedValue === selectedStatus) {
            smarttableref.current.querySelectorAll("button")[0].click();
          }
        };

        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };

        return (
          <Select
            isMulti={false}
            onChange={handleChange}
            closeMenuOnSelect={false}
            options={statusOptions}
            isClearable
            placeholder={t("SELECT")}
            value={statusOptions.find(
              (option) => option.value === selectedStatus
            )}
            defaultValue={selectedStatus}
            hideSelectedOptions={false}
            components={{ Option: CustomOption }}
            className="react-select-container singleSelecter"
            classNamePrefix="react-select"
          />
        );
      },
      sorter: false,
    },
    {
      label: <>{t("ACTIONS")}</>,
      key: "statusone",
      filter: false,
      sorter: false,
    },
  ];

  /**
   * Clears the selected options and triggers a click event on the first button in the smart table.
   * @returns None
   */
  const clearButtonFunction = () => {
    setRoleOptions([]);
    setDepotOptions([]);
    setMobileuserOptions([]);
    setStatusOptions([]);
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  // csv upload function
  /**
   * Handles the user file upload by setting the uploadedUserFile state with the provided files,
   * calling the handleBulkUserAdd function to process the files, and returning early if no files are provided.
   * @param {{FileList}} files - The list of files uploaded by the user.
   * @returns None
   */
  const handleUserFileUpload = (files) => {
    setuploadedUserFile(files);
    handleBulkUserAdd(files);
    if (files?.length === 0) return;
  };

  /**
   * Clears the uploaded user file by setting it to null.
   * @returns None
   */
  const handleClearUploadedUserFile = () => {
    setuploadedUserFile(null);
  };

  /**
   * Opens the import user modal by setting the state variable `showImportUserModal` to true.
   * @returns None
   */
  const openImportUserModal = () => {
    setshowImportUserModal(true);
  };
  /**
   * Closes the import user modal and resets the uploaded user file.
   * @returns None
   */
  const closeImportUserModal = () => {
    setshowImportUserModal(false);
    setuploadedUserFile(null);
  };

  // delete user functions
  /**
   * Deletes a user by updating their status to 'Deleted' and dispatches the necessary actions.
   * @returns None
   */
  const onDeleteUser = () => {
    // setLoaderButtonShow(true);
    dispatch(
      userDelete(
        deleteId,
        (res) => {
          setLoaderButtonShow(false);
          if (res) {
            dispatch(
              deleteUserReduxState(
                userList?.filter((item) => item?.userid !== deleteId)
              )
            );
          }
        },
        (err) => {
          setLoaderButtonShow(false);
          console.log(err);
        }
      )
    );
    closeDeleteUserModal();
  };
  const closeDeactiveModal = () => setShowStatusModal(false);
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const openDeleteUserModal = (e, item) => {
    setDeleteId(item?.userid);
    setshowDeleteUserModal(true);
  };

  /**
   * Handles the action when the user proceeds with disabling a notice type.
   * Updates the status of the notice type to "InActive" in the notice type array.
   * Closes the status modal.
   * Displays a success toast message.
   * @returns None
   */
  const onDeactivate = () => {
    setDisableModelLoaderBotton(true);
    const params = {
      userstatus: Constant.GENERALKEYS.INACTIVE,
    };
    dispatch(
      userEditStatus(
        enableDisableID?.userid,
        params,
        (res) => {
          if (res) {
            const _upatedList = userList?.map((item) => {
              if (item?.userid === enableDisableID?.userid) {
                return { ...item, userstatus: Constant.GENERALKEYS.INACTIVE };
              }
              return item;
            });
            dispatch(editUserStatusReduxState(_upatedList));
          }
          setShowStatusModal(false);
          setDisableModelLoaderBotton(false);
        },
        (err) => {
          setDisableModelLoaderBotton(false);
          console.log(err);
        }
      )
    );
  };
  /**
   * Handles the action when a checkbox is checked.
   * @param {{Event}} e - The event object.
   * @param {{object}} item - The item object associated with the checkbox.
   * @returns None
   */
  const onCheckAction = (e, item) => {
    setEnableDisableID(item);
    const status = item?.userstatus;
    if (status === Constant.GENERALKEYS.ACTIVE) {
      setShowStatusModal(true);
    } else {
      onActive(e, item?.userid);
    }
  };

  /**
   * Handles the action when unable to perform a certain action.
   * @param {Error} e - The error object that occurred.
   * @param {string} id - The ID of the item that the action was performed on.
   * @returns None
   */
  const onActive = (e, id) => {
    const params = {
      userstatus: Constant.GENERALKEYS.ACTIVE,
    };
    if (!toggleDisable.current) {
      toggleDisable.current = true;
      dispatch(
        userEditStatus(
          id,
          params,
          (res) => {
            if (res) {
              const _upatedList = userList?.map((item) => {
                if (item?.userid === id) {
                  return { ...item, userstatus: Constant.GENERALKEYS.ACTIVE };
                }
                return item;
              });
              dispatch(editUserStatusReduxState(_upatedList));
              toggleDisable.current = false;
            }
          },
          (err) => {
            toggleDisable.current = false;
            console.log(err);
          }
        )
      );
    }
  };

  /**
   * Event handler for checking a sign.
   * @param {{Event}} e - The event object.
   * @param {{object}} item - The item object representing the sign.
   * @returns None
   */
  const onCheckMobile = (e, item) => {
    onMobileUserCheck(e, item);
  };

  /**
   * Updates the signrequired property of an item in the noticeTypearray based on the provided id.
   * @param {{any}} e - The new value of the signrequired property.
   * @param {{string}} id - The id of the item in the noticeTypearray to update.
   * @returns None
   */
  const onMobileUserCheck = (e, item) => {

    if (item?.role === Constant.GENERALKEYS.MANAGER) {
      if (item?.allowmobilelogin === true) {
        const params = {
          allowmobilelogin: false,
        };
        if (!toggleDisable.current) {
          toggleDisable.current = true;

          dispatch(
            editUser(
              item?.userid,
              params,
              (res) => {
                if (res) {
                  const _upatedList = userList?.map((innerItem) => {
                    if (item?.userid === innerItem?.userid) {
                      return {
                        ...innerItem,
                        allowmobilelogin: !innerItem?.allowmobilelogin,
                      };
                    }
                    return innerItem;
                  });
                  dispatch(editUserSignStatusReduxState(_upatedList));
                  toggleDisable.current = false;
                }
              },
              (err) => {
                toggleDisable.current = false;
                console.log(err);
              }
            )
          );
        }
      } else {
        const params = {
          allowmobilelogin: true,
        };
        if (!toggleDisable.current) {
          toggleDisable.current = true;

          dispatch(
            editUser(
              item?.userid,
              params,
              (res) => {
                if (res) {
                  const _upatedList = userList?.map((innerItem) => {
                    if (item?.userid === innerItem?.userid) {
                      return {
                        ...innerItem,
                        allowmobilelogin: !innerItem?.allowmobilelogin,
                      };
                    }
                    return innerItem;
                  });
                  dispatch(editUserSignStatusReduxState(_upatedList));
                  toggleDisable.current = false;
                }
              },
              (err) => {
                toggleDisable.current = false;
                console.log(err);
              }
            )
          );
        }
      }
    } else {
      dispatch(
        showToast({
          message: "Your role is Driver",
          type: "error",
        })
      );
    }
  };

  /**
   * Handles the submission of an import file.
   * @returns None
   */
  const ImportFileSubmit = () => {
    dispatch(
      addcsvBulkUser(
        csvParsedData,
        bulkUserDataShowModal,
        setsuccessModalCsvData
      )
    );

    setuploadedUserFile(null);
  };

  const createUserFuction = () => {
    navigate("/usersManagement/createUser");
  };
console.log('userList',userList)
  const onTableFilterChange = (value) => {
    setSearchValue(value);
  
    // Filter the data based on the search value
    const filteredData = userList?.filter(item =>
      item?.fullname?.toLowerCase()?.includes(value.toLowerCase()) ||
      item?.emailid?.toLowerCase()?.includes(value.toLowerCase()) ||
      item?.phone?.toString()?.includes(value.toLowerCase()) ||
      item?.role?.toString()?.includes(value.toLowerCase()) ||
      item?.payno?.toString()?.includes(value.toLowerCase()) ||
      (item?.depotname && item?.depotname.some(dep => dep?.depotname.toLowerCase()?.includes(value.toLowerCase())))
    );
  
    // Update the state with the filtered data
    setSearchedData(filteredData);
  };

  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  /**
   * Downloads a sample file using the saveAs function.
   * @returns None
   */
  const onDownLoadSampleFile = () => {
    saveAs(scotRail_ImportUsers, "scotrail_users");
  };
  

  /**
   * Edit a user's information and navigate to the update user page.
   * @param {{Event}} e - The event object.
   * @param {{any}} item - The user item to be edited.
   * @returns None
   */
  const editUserFuction = (e, item) => {
    navigate("/usersManagement/updateuser", {
      state: {
        item,
      },
    });
  };

  /**
   * Clicks on the first button element found within the smart table referenced by `smarttableref`.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  /**
   * Function to load more items in a paginated list.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent excessive calls.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && userList?.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is added when the component mounts and removed when the component unmounts.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef?.current;

    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * Renders the UsersManagementComponent with the specified props.
   * @param {{boolean}} breadcrumbMainTitle - Whether to display the main title in the breadcrumb.
   * @param {{function}} openImportUserModal - Function to open the import user modal.
   * @param {{array}} UserItem - Array of user data.
   * @param {{string}} tableName - Name of the table.
   * @param {{string}} searchPlaceHolder - Placeholder text for the search input.
   * @param {{array}} columns - Array of column data.
   * @param {{function}} showStatusModal - Function to show the status modal.
   * @param {{function}} showImportUserModal - Function to show the import user modal.
   * @param {{object}}
   */
  return (

    <>
    <Helmet>
      <title>User Management | ScotRail Safety Notice Portal</title>
    </Helmet>
    <UsersManagementComponent
      breadcrumbMainTitle={true}
      openImportUserModal={openImportUserModal}
      UserItem={userList}
      tableName={tableName}
      searchPlaceHolder={t("SEARCH_BY_NAME_OR_EMAIL_ADDRESS")}
      columns={columns}
      showStatusModal={showStatusModal}
      showImportUserModal={showImportUserModal}
      uploadedUserFile={uploadedUserFile}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item);
      }}
      closeDeactiveModal={closeDeactiveModal}
      closeDeleteUserModal={closeDeleteUserModal}
      onDeleteUser={onDeleteUser}
      showDeleteUserModal={showDeleteUserModal}
      closeImportUserModal={closeImportUserModal}
      placeHolderShimer={placeHolder}
      handleUserFileUpload={handleUserFileUpload}
      handleClearUploadedUserFile={handleClearUploadedUserFile}
      onCheckMobile={(e, item) => onCheckMobile(e, item)}
      onCheckAction={(e, item) => onCheckAction(e, item)}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_USERS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      noDataTitle={t("NO_RESULT_FOUND")}
      noDataFound={t("NO_DATA_FOUND")}
      noDataAddButton={true}
      onProcced={onDeactivate}
      noDataAddButtonTitle={t("CREATE_USER")}
      ImportFileSubmit={ImportFileSubmit}
      createUserFuction={createUserFuction}
      editUserFuction={(e, item) => {
        editUserFuction(e, item);
      }}
      clearButtonFunction={clearButtonFunction}
      roleOptions={roleOptions}
      depotOptions={depotOptions}
      mobileuserOptions={mobileuserOptions}
      statusOptions={statusOptions}
      smarttableref={smarttableref}
      clearSearchButton={clearSearchButton}
      tableContainerRef={tableContainerRef}
      itemsPerPage={pageSizeRef.current}
      dimensions={dimensions}
      loading={loading}
      tableFilterHeight={tableFilterHeight}
      breadcrumbHeight={breadcrumbHeight}
      tabHeaderHeight={tabHeaderHeight}
      headerHeight={headerHeight}
      loaderHtml={loaderHtml}
      loaderButtonShow={loaderButtonShow}
      disableModelLoaderBotton={disableModelLoaderBotton}
      successModalTitle={successModalCsvData.title}
      successModalEmptyRows={successModalCsvData.emptyRows}
      successModalFailedTotal={successModalCsvData.failed}
      successModalShow={showCsvSuccessModal}
      successModalValidRows={successModalCsvData.validRows}
      successModalInvalidRows={successModalCsvData.invalidRows}
      successModalHandleClose={handleCsvSuccessModalClose}
      successModalTotal={successModalCsvData.total}
      downLoadButton={onDownLoadSampleFile}
      onTableFilterChange={onTableFilterChange}
      searchFilterClear={searchFilterClear}
      searchValue={searchValue}
      searchedData={searchedData}
    />
  </>
  );
};

export default UsersManagementContainer;
